module.exports = __webpack_public_path__ + "media/images/new/icons/mall-0-138a2a3d419b245746955e187ef242c2.png";